var BASE_PATH = '/api/teams';
var QA_SERVER_URL = "https://api-consumer-client-qa.doordash.com" + BASE_PATH;
var LOCAL_SERVER_URL = "http://localhost:3000" + BASE_PATH;
var GRAPHQL_URL = '/graphql';
var QA_GRAPHQL_URL = "https://api-consumer-client-qa.doordash.com" + GRAPHQL_URL;
var LOCAL_GRAPHQL_URL = "http://localhost:3000" + GRAPHQL_URL;
export var SENTRY_DSN_KEY = 'https://aa6185bd202d4eb8a846f52069f52d77@o17585.ingest.sentry.io/5782531';
export var getFallbackServerUrl = function () {
    return process.env.NODE_ENV === 'production'
        ? BASE_PATH
        : process.env.NODE_ENV === 'QA'
            ? QA_SERVER_URL
            : LOCAL_SERVER_URL;
};
export var getFallbackGraphqlUrl = function () {
    return process.env.NODE_ENV === 'production'
        ? GRAPHQL_URL
        : process.env.NODE_ENV === 'QA'
            ? QA_GRAPHQL_URL
            : LOCAL_GRAPHQL_URL;
};
